import { createAsyncThunk } from '@reduxjs/toolkit';
import { AccountService } from '../services/account.service';
import { showCriticalAlert } from './common.actions';
import i18n from '../i18n';

interface ConfirmAgeParams {
    dateOfBirth?: string;
}

export const confirmAge = createAsyncThunk(
    'account/confirmAge',
    async (params: ConfirmAgeParams, { rejectWithValue, dispatch }) => {
        try {
            const confirmInfo = await AccountService.confirmAge(params?.dateOfBirth);
            return confirmInfo;
        } catch (error) {
            dispatch(showCriticalAlert(i18n.t('epic.common.network.error')));
            return rejectWithValue(
                error instanceof Error ? error.message : 'Unknown error occurred'
            );
        }
    }
);
